export default __webpack_public_path__ + "static/media/mobile_fundraise.7407a456.mp4";